const GTAG_URL = 'https://www.googletagmanager.com/gtag/js';

/**
 * Emits a GA4 event when analytics is initialised, and no-ops otherwise, so
 * callers never need to guard on the measurement id themselves.
 */
export function trackEvent(name, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params || {});
}

export function initGoogleAnalytics() {
    const measurementId =
        process.env.REACT_APP_GA_MEASUREMENT_ID ||
        window._env_?.REACT_APP_GA_MEASUREMENT_ID;

    if (!measurementId || window.gtag) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    const script = document.createElement('script');
    script.async = true;
    script.src = `${GTAG_URL}?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
}
